export default {
    scrollCurrentConversationToBottom() {
        var div = document.getElementsByClassName('conversation__body-scrollable')[0]

        setTimeout(() => {
            div.scrollTop = div.scrollHeight;
        }, 200)
    },
    focusConversationInputField() {
        document.getElementById('composePanelInput').focus();
    },
    focusHeaderInputField() {
        const el = document.getElementById('headerInputField')
        if (el) el.focus();
    },
    enableSmoothConversationScrolling(b) {
        if(document.getElementsByClassName('conversation__body-scrollable')[0]) {
            const el = document.getElementsByClassName('conversation__body-scrollable')[0]
            el.style.scrollBehavior = b ? 'smooth' : 'auto'
        }
    },
    getHeightOfElement(el) {
        if(el) return el.style.height
    }

}